import React from 'react'
import styles from './styles.css'

export default function Typing(props) {
  return (
    <div className={styles.container}>
      <div className={styles.text}>El driver esta escribiendo...</div>
    </div>
  )
}
